/**
 * @prettier
 * @flow
 */
import type { PaymentLinkId } from 'src/types/Id';

export function parsePaymentLinkId(value: any): PaymentLinkId {
    return (parseInt(value): any);
}
